import { call, put } from 'redux-saga/effects';
import { photoCaptureGetFraudWarningDataSuccessAction, photoCaptureDataFailureAction } from '../actions';
import { PhotoCaptureFraudWarningService } from '../services';
export function* photoCaptureGetFraudWarningSaga(action, photoCaptureFraudWarningService = PhotoCaptureFraudWarningService.getInstance()) {
    const { coCode, taskId, language } = action.payload;
    try {
        const response = yield call({
            context: photoCaptureFraudWarningService,
            fn: photoCaptureFraudWarningService.photoCaptureGetFraudWarningData
        }, coCode, taskId, language);
        yield put(photoCaptureGetFraudWarningDataSuccessAction(response.FraudStatementResult));
    }
    catch (error) {
        yield put(photoCaptureDataFailureAction(error.toString()));
    }
}
//# sourceMappingURL=photoCaptureGetFraudWarningSaga.js.map